export const TradeModeEvent = {
  TradeSettingsView: 'trade_settings_view',
  /**
   * @deprecated
   */
  TradeSettingsPositionModeClick: 'trade_settings_position_mode_click',
  TradeSettingsSelectClick: 'trade_settings_select_click',
  TradeSettingsConfirmClick: 'trade_settings_confirm_click',
  SetPositionModePageView: 'set_position_mode_page_view',
  /**
   * @deprecated
   */
  PositionModeConfirmClick: 'position_mode_confirm_click',
  /**
   * @deprecated
   */
  PositionModeCancelClick: 'position_mode_cancel_click',
  TradeSettingsBackClick: 'trade_settings_back_click',
  CloseAllTradesView: 'close_all_trades_view',
  CloseAllTradesViewOrdersClick: 'close_all_trades_view_orders_click',
} as const;

export type PositionMode = 'oneway' | 'multiposition';
export type DisplayedLeverageTypeRawValue = 'Position leverage' | 'Effective leverage';

export interface TradeModeEventDataType {
  [TradeModeEvent.TradeSettingsSelectClick]: {
    list_order: number;
    menu_name: string;
    is_new: boolean;
  };
  [TradeModeEvent.TradeSettingsConfirmClick]:
    | {
        setting_name: 'Position modes';
        option_name: PositionMode;
      }
    | {
        setting_name: 'Set displayed leverage';
        option_name: DisplayedLeverageTypeRawValue;
      };
  [TradeModeEvent.TradeSettingsBackClick]: {
    setting_name: 'Position modes' | 'Set displayed leverage';
  };
}
